import { ConferenciaComponent } from './../conferencia/conferencia.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FeriaPersonalizadaComponent } from '../feria-personalizada/feria-personalizada.component';

@Component({
  selector: 'app-evento-feria-personalizada',
  templateUrl: './evento-feria-personalizada.component.html',
  styleUrls: ['../evento-feria-escolar/evento-feria-escolar.component.scss'],
})
export class EventoFeriaPersonalizadaComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRefEvento: MatDialogRef<EventoFeriaPersonalizadaComponent>
  ) {}

  ngOnInit(): void {}

  openEConferenciaModal() {
    const dialogRef = this.dialog.open(FeriaPersonalizadaComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRefEvento.close();
  }
  onCancel(): void {
    this.dialogRefEvento.close();
  }
}
